// extracted by mini-css-extract-plugin
module.exports = {"content":"index-content-1-0hQ","close_btn":"index-close_btn-2G3EZ","qrcode_box":"index-qrcode_box-jt1aD","loading_img":"index-loading_img-1hrLc"};